
export default class commonUtils{

  static isStringNull(str) {
    if (str == null || str == undefined || str == ""){
      return true;
    }
    return false;
  }
  static isObjectNull(str) {
    if (str == null || str == undefined ){
      return true;
    }
    return false;
  }
  static isArrayNull(arr) {
    if (arr == null || arr == undefined || arr.length <=0){
      return true;
    }
    return false;
  }

  static getObjectBuyId(array,id){
    if (commonUtils.isObjectNull(array)){
      return null;
    }
    for (let i =0;i< array.length;++i){
      if (array[i].id == id){
        return array[i];
      }
    }
    return null;
  }


}



// WEBPACK FOOTER //
// ./src/utils/commonUtils.js